import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  computed,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { WHButtonComponent } from '../buttons/w-h-button/w-h-button.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import {
  FLOW_GATEWAY,
  IWHBomNodeEndpointConfigModel,
  IWHEntryFileDTO,
  IWHWorkOrderFileDTO,
  WHBomNodeDataService,
  WHEntryFileDOM,
  WHFileDOM,
  WHFlowMetadataDOM,
  WHFileUploadDataService,
  WHMetadataDataService,
  WHToastService,
} from '@workheld/workheld-shared-lib';
import {
  catchError,
  forkJoin,
  map,
  of,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import {
  IWHSanitizedFileList,
  WHFileAsyncService,
} from 'src/app/app-services-async/w-h-file-async.service';
import { WorkOrderFileAsyncService } from 'src/app/app-services-async/work-order-file-async.service';
import { AppSharedModule } from 'src/app/app-shared/app-shared.module';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CdkDropList,
  CdkDrag,
  CdkDragPlaceholder,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { WHLinkComponent } from './w-h-link.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WHSearchTermUtilModule } from '../../../app-modules-pages/w-h-search-term-util/w-h-search-term-util.module';
import { WHPipesModule } from '../../shared-pipes/wh-pipes.module';
import { EntryFileAsyncService } from 'src/app/app-services-async/entry-file-async.service';
import { DataModelHelperService } from 'src/app/app-services-helper/data-model-helper.service';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDialogImagePreviewEntryComponent } from 'src/app/app-dialogs/mat-dialog-image-preview-entry/mat-dialog-image-preview-entry.component';

@UntilDestroy()
@Component({
  selector: 'w-h-file-dnd-zone',
  styles: `
    :host {
      height: 100%;
      display: block;
    }
    .thumbnail-container {
      width: 32px;
      height: 32px;
      overflow: hidden;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      overflow: hidden;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .dropzone {
      height: 280px;
      max-width: 100%;
      position: relative;
    }
    .loading-overlay {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
    }

    .cdk-drag-placeholder {
      opacity: 0;
    }

    .draggable-list-item {
      padding: 8px 0px;
      color: rgba(0, 0, 0, 0.87);
      display: flex;
      flex-direction: row;
      height: 65px;
      border-bottom: 1px solid #d6d6d6;
      align-items: center;
      background: #f4f4f4;
      justify-content: space-between;
      box-sizing: border-box;
      position: relative;
      width: 100%;

      .drag-handler {
        opacity: 0;
        transition: 0.3s;
        cursor: move;
      }

      .actions {
        display: none;
        position: absolute;
        right: 0;
        width: 100%;
        justify-content: flex-end;

        & > div {
          z-index: 2;
          padding-left: 48px;
          background: linear-gradient(
            90deg,
            rgba(244, 244, 244, 0) 0%,
            rgb(244, 244, 244) 14%
          );
        }
      }

      &:hover {
        .drag-handler {
          opacity: 1;
        }

        .actions {
          display: flex;
        }
      }

      &.cdk-drag-placeholder {
        .drag-handler {
          opacity: 1;
        }
      }
    }

    .cdk-drag-preview {
      border: none;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow:
        0 5px 5px -3px rgba(0, 0, 0, 0.1),
        0 8px 10px 1px rgba(0, 0, 0, 0.08),
        0 3px 14px 2px rgba(0, 0, 0, 0.05);
    }
    .cdk-drag-animating {
      transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
    }

    .draggable-list-item:last-child,
    .draggable-list-item.last-item {
      border: none;
    }

    .draggable-list.cdk-drop-list-dragging
      .draggable-list-item:not(.cdk-drag-placeholder) {
      transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
    }

    .draggable-list.cdk-drop-list-dragging .draggable-list-item .actions {
      display: none !important;
    }
  `,
  imports: [
    AppSharedModule,
    TranslateModule,
    AppSharedModule,
    MatDividerModule,
    MatButtonModule,
    CdkScrollable,
    CdkDropList,
    CdkDrag,
    CdkDragPlaceholder,
    MatTooltipModule,
    ReactiveFormsModule,
    WHLinkComponent,
    WHSearchTermUtilModule,
    WHPipesModule,
    WHButtonComponent,
  ],
  template: `
    @let isSearchActive = filteredFileList()?.length !== fileDomArray()?.length;
    @let isEquipmentView = type === 'EQUIPMENT';

    <div class="dropzone flex--col">
      @if (loading()) {
        <mat-spinner class="loading-overlay" diameter="18"></mat-spinner>
      }
      @if (!loading() && filteredFileList().length === 0) {
        <div class="loading-overlay">
          {{ 'app.nodata.label' | translate }}
        </div>
      }
      <div
        class="flex--r-c-sb gap--8 p--8"
        style="border-bottom: 1px solid #d6d6d6; box-sizing: border-box;"
      >
        <ng-bee-w-h-search-term-util
          class="flex-1"
          [focusElement]="false"
          [isCharTriggerLimited]="false"
          (onSearchTermInput)="handleSearchTermInput($event)"
        >
        </ng-bee-w-h-search-term-util>
        @if (!loading()) {
          <span>
            {{ filteredFileList()?.length }}
            {{ 'app.ui.documentsFound' | translate }}
          </span>
        }
      </div>
      <div
        class="flex-1"
        style="height: 100%; overflow-y: auto; overflow-x: hidden; max-height: 450px"
        cdkScrollable
      >
        <div
          cdkDropList
          class="draggable-list"
          [cdkDropListData]="filteredFileList()"
          [cdkDropListOrientation]="'vertical'"
          cdkDropListLockAxis="y"
          (cdkDropListDropped)="onListDrop($event)"
          [cdkDropListDisabled]="
            filteredFileList()?.length !== fileDomArray()?.length ||
            !isEquipmentView ||
            isReadOnly
          "
        >
          @for (file of filteredFileList(); track file.id) {
            <div
              class="flex--r-c-sb p--4 draggable-list-item"
              [ngClass]="{ 'last-item': $last }"
              [ngStyle]="{ opacity: loading() ? '0.6' : '1' }"
              cdkDrag
            >
              <div
                *cdkDragPlaceholder
                style="display: block !important; opacity: 0 !important; height: 65px; box-sizing: border-box;"
              ></div>
              @if (editingFile() && editingFile().id === file.id) {
                <w-h-link
                  class="p-l--8 p-r--8"
                  [initialValues]="editingFile()"
                  (onSubmit)="handleSubmit($event)"
                  (onCancel)="editingFile.set(null)"
                ></w-h-link>
              } @else {
                <div
                  class="flex--r-c gap--8"
                  [ngClass]="{
                    'p-l--16': isSearchActive || !isEquipmentView || isReadOnly,
                  }"
                  style="width: 100%"
                >
                  @if (!isSearchActive && isEquipmentView && !isReadOnly) {
                    <mat-icon
                      class="drag-handler"
                      data-cy="drag-handler"
                      cdkDragHandle
                      >drag_indicator</mat-icon
                    >
                  }
                  @if (!file.mimeType) {
                    <mat-icon matListItemIcon>link</mat-icon>
                  } @else if (
                    file.mimeType?.includes('image') && file.thumbnailURL
                  ) {
                    <div class="thumbnail-container">
                      <img
                        *ngIf="
                          file.thumbnailURL
                            | WHImgAuthHeader: 'noCache'
                            | async as image
                        "
                        [src]="image"
                      />
                    </div>
                  } @else {
                    <mat-icon matListItemIcon>{{
                      file.mimeType | mimeTypeIcon
                    }}</mat-icon>
                  }
                  <div class="flex--col" style="width: 89%">
                    <div
                      style="white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 100%;
                        display: block;
                        width: 100%;"
                    >
                      <span>{{ file.fileName }}</span>
                    </div>
                    <div
                      style="z-index: 1"
                      [matTooltip]="file.bomNodeFile?.documentUrl"
                    >
                      {{
                        file.bomNodeFile?.documentUrl
                          ? (file.bomNodeFile?.documentUrl | shortenUrl) + ' • '
                          : ''
                      }}
                      {{ file.modifiedDate | date }}
                    </div>
                  </div>
                </div>
              }

              @if (!editingFile()) {
                <div class="actions">
                  <div class="flex--r-c gap--4">
                    @if (!file.isTemporary) {
                      @if (file.mimeType) {
                        @if (file?.mimeType?.includes('pdf')) {
                          <button
                            [disabled]="loading()"
                            color="accent"
                            [matTooltip]="'app.ui.openInNewTab' | translate"
                            (click)="downloadFile(file, true)"
                            mat-icon-button
                          >
                            <mat-icon>open_in_new</mat-icon>
                          </button>
                        }
                        @if (file?.mimeType?.includes('image')) {
                          <button
                            [disabled]="loading()"
                            color="accent"
                            [matTooltip]="'app.view.label' | translate"
                            (click)="openImagePreviewDialog(file)"
                            mat-icon-button
                          >
                            <mat-icon>visibility</mat-icon>
                          </button>
                        }
                        <button
                          [disabled]="loading()"
                          color="accent"
                          [matTooltip]="'app.download.label' | translate"
                          (click)="downloadFile(file)"
                          mat-icon-button
                        >
                          <mat-icon>file_download</mat-icon>
                        </button>
                      } @else {
                        <button
                          [disabled]="loading()"
                          (click)="openLink(file)"
                          [matTooltip]="'app.ui.openInNewTab' | translate"
                          color="accent"
                          mat-icon-button
                        >
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                        <button
                          [disabled]="loading()"
                          [matTooltip]="'app.ui.copyLink' | translate"
                          (click)="copyLink(file)"
                          color="accent"
                          mat-icon-button
                        >
                          <mat-icon>content_copy</mat-icon>
                        </button>
                        <button
                          [disabled]="loading() || isReadOnly"
                          data-cy="edit-file-button"
                          (click)="handleEdit(file)"
                          [matTooltip]="'app.edit.label' | translate"
                          color="accent"
                          mat-icon-button
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                    }

                    <button
                      [disabled]="loading() || isReadOnly"
                      (click)="deleteFile(file, file.isTemporary)"
                      data-cy="delete-file-button"
                      [matTooltip]="'app.delete.label' | translate"
                      color="warn"
                      mat-icon-button
                    >
                      <mat-icon>delete_forever</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div
        style="width: 100%; box-sizing: border-box; border-top: 1px solid #d6d6d6"
        class="flex--c-c gap--8"
        [ngClass]="{ 'p--8': !isReadOnly }"
      >
        @if (isLinkFormVisible()) {
          <w-h-link
            (onSubmit)="handleSubmit($event)"
            (onCancel)="isLinkFormVisible.set(false)"
          ></w-h-link>
        } @else if (!isReadOnly) {
          <div class="flex--r-c-c gap--8">
            <w-h-button
              style="width: 100%;"
              [text]="'app.upload.label' | translate"
              matIcon="file_upload"
              type="stroked"
              color="accent"
              [disabled]="loading() || isReadOnly"
              dataCy="upload-button"
              (clicked)="openFilePicker()"
            />

            @if (isEquipmentView) {
              <button
                style="width: 100%;"
                [disabled]="loading() || isReadOnly"
                data-cy="create-link-button"
                (click)="showLinkForm()"
                color="accent"
                mat-stroked-button
              >
                <mat-icon>link</mat-icon>
                @if (isLinkFormVisible()) {
                  {{ 'app.cancel.label' | translate }}
                } @else {
                  {{ 'app.ui.createLink.label' | translate }}
                }
              </button>
            }
          </div>
        }
      </div>

      <input
        #dndFileInput
        style="display: none;"
        type="file"
        name="file"
        id="file"
        (change)="onFileChange($event)"
        multiple
      />
    </div>
  `,
})
export class WHFileDragNDropComponent implements OnInit, OnChanges {
  @Input() targetId: string;
  @Input() type: 'EQUIPMENT' | 'WORK_ORDER' | 'ENTRY'; // extend this as needed because of different endpoints
  @Input() uploadSuccessNotification: string;
  @Input() deleteSuccessNotification: string;
  @Input() isReadOnly: boolean;
  /**
   * Defers persistence: uploads and deletes are staged locally and the parent
   * persists them on its own SAVE (WHP-12151). Only supported for `ENTRY`.
   */
  @Input() isStaged = false;
  @Output() handleDrop = new EventEmitter();
  @Output() filesToUpload = new EventEmitter();
  @ViewChild('dndFileInput', { static: true }) dndFileInput: ElementRef;
  loading = signal(false);
  fileDomArray = signal([]);
  filteredFileList = signal([]);
  allowedFileExtensions = [];
  editingFile = signal(null);
  isLinkFormVisible = signal(false);
  searchTerm: string;
  /** Files picked but not yet uploaded, keyed by the synthetic id of their list row. */
  readonly stagedUploads = signal<{ tempId: string; file: File }[]>([]);
  /** Ids of already persisted files the user removed but which are not deleted yet. */
  readonly stagedDeletionIds = signal<string[]>([]);
  readonly hasStagedChanges = computed(
    () =>
      this.stagedUploads().length > 0 || this.stagedDeletionIds().length > 0,
  );
  private stagedUploadSeq = 0;
  constructor(
    private _snackBar: MatSnackBar,
    private fileDataService: WHFileAsyncService,
    private workheldFileAsyncService: WHFileAsyncService,
    private workOrderFileAsyncService: WorkOrderFileAsyncService,
    private fileUploadDataService: WHFileUploadDataService,
    private bomNodeDataService: WHBomNodeDataService,
    private metadataDataService: WHMetadataDataService,
    private ngxToastrService: WHToastService,
    private translateService: TranslateService,
    private entryFileAsyncService: EntryFileAsyncService,
    private dataModelHelperService: DataModelHelperService,
    private matDialog: MatDialog,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.targetId?.currentValue) {
      this.getFileList(changes.targetId.currentValue);
    }
  }

  ngOnInit(): void {
    this.metadataDataService.metadataDOM$
      .pipe(untilDestroyed(this))
      .subscribe((metadataDOM: WHFlowMetadataDOM) => {
        this.allowedFileExtensions = metadataDOM.allowedFileExtensions;
      });
  }

  public onFileChange(files): void {
    if (files?.target) {
      files = files.target.files;
    }

    if (files.length === 0) {
      return;
    }

    // VALIDATE
    const sanitizedFileList: IWHSanitizedFileList =
      this.fileDataService.sanitizeFileList(files, this.allowedFileExtensions);
    if (sanitizedFileList.notAllowedFileExtensionList.length > 0) {
      this.ngxToastrService.info('ERROR.WHFILE_BR_FILE_5');
    }
    if (sanitizedFileList.notAllowedFileSizeList.length > 0) {
      this.ngxToastrService.info(
        'clienterror.fileupload.maxsizeexceeded.notification',
      );
    }
    if (sanitizedFileList.allowedFileList.length === 0) {
      return;
    }

    this.loading.set(true);

    const allowedFileList = sanitizedFileList.allowedFileList;
    if (this.type === 'EQUIPMENT') {
      this.fileUploadDataService
        .uploadFiles(
          {
            apiUrl: environment.apiUrl + FLOW_GATEWAY,
          },
          {
            targetType: 'BOM_NODE',
            targetId: this.targetId,
          },
          allowedFileList,
        )
        .pipe(
          untilDestroyed(this),
          switchMap((_) => {
            this.getFileList(this.targetId);
            return of(null);
          }),
          catchError((error: HttpErrorResponse) => {
            this.loading.set(false);
            return throwError(() => error);
          }),
        )
        .subscribe();
    } else if (this.type === 'WORK_ORDER') {
      this.workOrderFileAsyncService
        .uploadWorkOrderDocuments(
          this.targetId,
          sanitizedFileList.allowedFileList,
        )
        .pipe(
          untilDestroyed(this),
          switchMap((_) => {
            this.getFileList(this.targetId);
            return of(null);
          }),
          catchError((error: HttpErrorResponse) => {
            this.loading.set(false);
            return throwError(() => error);
          }),
        )
        .subscribe();
    } else if (this.type === 'ENTRY') {
      // No target yet (create flow) or deferred persistence (edit flow): stage
      // the files and let the parent upload them on its own SAVE.
      if (!this.targetId || this.isStaged) {
        this.loading.set(false);
        this.stageUploads(allowedFileList);
        this.emitStagedFiles();

        return;
      }

      forkJoin(
        allowedFileList.map((file: File) =>
          this.entryFileAsyncService.uploadEntryFile(this.targetId, file),
        ),
      )
        .pipe(
          untilDestroyed(this),
          switchMap(() => {
            this.getFileList(this.targetId);
            return of(null);
          }),
          catchError((error: HttpErrorResponse) => {
            this.loading.set(false);
            return throwError(() => error);
          }),
        )
        .subscribe();
    }
  }

  handleSearchTermInput(term) {
    this.searchTerm = term;
    if (!term) {
      this.filteredFileList.set(this.fileDomArray());
    } else {
      const lowerTerm = term.toLowerCase();
      this.filteredFileList.set(
        this.fileDomArray().filter((fileDOM) => {
          return (
            fileDOM.bomNodeFile?.fileName?.toLowerCase().includes(lowerTerm) ||
            fileDOM.fileName?.toLowerCase().includes(lowerTerm)
          );
        }),
      );
    }
  }

  openImagePreviewDialog(row): MatDialogRef<{}, any> {
    let image = null;
    if (this.type === 'WORK_ORDER') {
      image = row.workOrderFile;
    } else if (this.type === 'EQUIPMENT') {
      image = row.whFileDto;
    } else if (this.type === 'ENTRY') {
      image = row.entryFile;
    }

    return this.matDialog.open(MatDialogImagePreviewEntryComponent, {
      autoFocus: false,
      data: {
        image,
        comment: '',
      },
    } as MatDialogConfig);
  }

  downloadFile(
    fileDOM: WHFileDOM & { entryFile?: any },
    openInNewTab?: boolean,
  ) {
    let fileToDownload = null;
    if (this.type === 'WORK_ORDER') {
      fileToDownload = fileDOM.workOrderFile;
    } else if (this.type === 'EQUIPMENT') {
      fileToDownload = fileDOM.whFileDto;
    } else if (this.type === 'ENTRY') {
      fileToDownload = fileDOM.entryFile;
    }

    this.fileDataService
      .downloadWHFileBlob(fileToDownload)
      .pipe(untilDestroyed(this))
      .subscribe((fileBlob: Blob) => {
        if (openInNewTab && fileDOM?.mimeType?.includes('pdf')) {
          const blobUrl = URL.createObjectURL(fileBlob);
          window.open(blobUrl, '_blank');
        } else {
          this.fileDataService.saveFile(fileToDownload, fileBlob);
        }
      });
  }

  async deleteFile(whFileDOM: WHFileDOM, isTemporary?: boolean) {
    if (isTemporary) {
      this.stagedUploads.update((prev) =>
        prev.filter(({ tempId }) => tempId !== whFileDOM.id),
      );
      this.removeFromFileLists(whFileDOM.id);
      this.emitStagedFiles();
    } else if (this.isStaged) {
      // Only remembered here — the parent deletes it on SAVE.
      this.stagedDeletionIds.update((prev) => [...prev, whFileDOM.id]);
      this.removeFromFileLists(whFileDOM.id);
    } else {
      this.loading.set(true);

      this.workheldFileAsyncService
        .deleteDocumentWHFile(whFileDOM.id, this.type)
        .pipe(untilDestroyed(this))
        .subscribe((res: null) => {
          const files = this.fileDomArray().filter((fileDOM: WHFileDOM) => {
            return whFileDOM.id !== fileDOM.id;
          });
          this.fileDomArray.set(files);
          this.filteredFileList.set(files);

          this.handleSearchTermInput(this.searchTerm);

          this.ngxToastrService.success(this.deleteSuccessNotification);
          this.loading.set(false);
        });
    }
  }

  handleSubmit(payload) {
    const endpointConfig = { apiUrl: environment.apiUrl + FLOW_GATEWAY };

    payload.bomNodeId = this.targetId;

    if (payload.id) {
      this.bomNodeDataService
        .updateBomNodeLink(
          {
            apiUrl: environment.apiUrl + FLOW_GATEWAY,
            id: payload.id,
          },
          payload,
        )
        .pipe(
          untilDestroyed(this),
          tap((response: any) => {
            const file = this.filteredFileList().find(
              (file) => file.id === payload.id,
            );
            file.fileName = response.bomNodeFile.fileName;
            file.bomNodeFile.documentUrl = response.bomNodeFile.documentUrl;
          }),
        )
        .subscribe();
    } else {
      this.bomNodeDataService
        .createBomNodeLink(endpointConfig, [payload])
        .pipe(
          untilDestroyed(this),
          switchMap((_) => {
            this.getFileList(this.targetId);
            return of(null);
          }),
          catchError((error: HttpErrorResponse) => {
            this.loading.set(false);
            return throwError(() => error);
          }),
        )
        .subscribe();
    }
  }

  onListDrop(event) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    const reorderedFiles = [...this.filteredFileList()];
    moveItemInArray(reorderedFiles, event.previousIndex, event.currentIndex);

    this.filteredFileList.set(reorderedFiles);
    this.fileDomArray.set(reorderedFiles);

    reorderedFiles.forEach((file, index) => {
      const nextSortPosition = index + 1;
      if (nextSortPosition !== file.sortPosition) {
        this.bomNodeDataService
          .updateBomNodeLink(
            {
              apiUrl: environment.apiUrl + FLOW_GATEWAY,
              id: file.id,
            },
            {
              ...file,
              sortPosition: nextSortPosition,
            },
          )
          .pipe(untilDestroyed(this))
          .subscribe();

        file.sortPosition = nextSortPosition;
      }
    });
  }

  handleEdit(file) {
    this.editingFile.set({
      fileName: file.fileName,
      id: file.id,
      documentUrl: file.bomNodeFile.documentUrl,
      sortPosition: file.sortPosition,
    });
  }

  openLink(file) {
    window.open(file.bomNodeFile.documentUrl, '_blank');
  }

  copyLink(file) {
    navigator.clipboard.writeText(file.bomNodeFile.documentUrl).then(
      () => {
        this._snackBar.open(
          this.translateService.instant('app.ui.copiedToClipboard'),
          '',
          { duration: 2000 },
        );
      },
      (err) => {
        console.error('Failed to copy text to clipboard: ', err);
      },
    );
  }

  onDrop(event: any) {
    this.handleDrop.emit({ event, id: event?.event?.toElement?.id });
  }

  openFilePicker() {
    this.dndFileInput.nativeElement.click();
  }

  showLinkForm() {
    this.isLinkFormVisible.update((value) => !value);
  }

  /**
   * Drops every staged upload/deletion and shows the persisted state again.
   * Called by the parent on both CANCEL (abort) and SAVE (re-sync).
   */
  resetStagedChanges(): void {
    const hadStagedChanges = this.hasStagedChanges();
    this.stagedUploads.set([]);
    this.stagedDeletionIds.set([]);

    if (hadStagedChanges) {
      this.emitStagedFiles();
    }

    if (!this.targetId) {
      this.fileDomArray.set([]);
      this.filteredFileList.set([]);
      return;
    }

    if (hadStagedChanges) {
      this.getFileList(this.targetId);
    }
  }

  private stageUploads(files: File[]): void {
    const staged = files.map((file) => ({
      tempId: `staged-${this.stagedUploadSeq++}`,
      file,
    }));

    this.stagedUploads.update((prev) => [...prev, ...staged]);
    this.fileDomArray.update((prev) =>
      prev.concat(
        staged.map(({ tempId, file }) => ({
          id: tempId,
          fileName: file.name,
          mimeType: file.type,
          isTemporary: true,
        })),
      ),
    );
    this.handleSearchTermInput(this.searchTerm);
  }

  private removeFromFileLists(fileId: string): void {
    this.fileDomArray.update((prev) =>
      prev.filter((file) => file.id !== fileId),
    );
    this.handleSearchTermInput(this.searchTerm);
  }

  private emitStagedFiles(): void {
    this.filesToUpload.emit(this.stagedUploads().map(({ file }) => file));
  }

  private getFileList(targetId) {
    this.loading.set(true);
    if (this.type === 'WORK_ORDER') {
      this.workOrderFileAsyncService
        .getWorkOrderFileDtoList(targetId)
        .pipe(untilDestroyed(this))
        .subscribe((workOrderFileDtoList: IWHWorkOrderFileDTO[]) => {
          this.fileDomArray.set(workOrderFileDtoList);
          this.filteredFileList.set(workOrderFileDtoList);
          this.sortBySortPosition();
          this.loading.set(false);
        });
    } else if (this.type === 'EQUIPMENT') {
      this.bomNodeDataService
        .getBomNodeFileDtoList({
          bomNodeId: targetId || this.targetId,
          workOrderId: targetId || this.targetId,
          apiUrl: environment.apiUrl + FLOW_GATEWAY,
        } as IWHBomNodeEndpointConfigModel)
        .pipe(untilDestroyed(this))
        .subscribe((fileDtoList: any[]) => {
          this.fileDomArray.set([]);
          this.filteredFileList.set([]);
          if (fileDtoList && fileDtoList.length > 0) {
            fileDtoList.forEach((fileDTO: any) => {
              let fileDOM = new WHFileDOM().initBomNodeFileDOM(fileDTO);
              this.fileDomArray.update((prev) => [...prev, fileDOM]);
            });

            this.filteredFileList.set(this.fileDomArray());
            this.sortBySortPosition();

            this.loading.set(false);
          } else {
            this.loading.set(false);
          }
        });
    } else if (this.type === 'ENTRY') {
      if (!this.targetId) return;

      this.entryFileAsyncService
        .getEntryFileDtoListByEntryId(this.targetId)
        .pipe(
          map((entryFileDtoArray: IWHEntryFileDTO[]) => {
            this.fileDomArray.set([]);
            this.filteredFileList.set([]);
            const entryFiles: WHEntryFileDOM[] = [];
            if (entryFileDtoArray) {
              entryFileDtoArray.forEach((entryFileDTO: IWHEntryFileDTO) => {
                const entryFileDOM: WHEntryFileDOM =
                  this.dataModelHelperService.initEntryFileDOM(entryFileDTO);
                entryFiles.push(entryFileDOM);
              });
            }
            this.fileDomArray.set(entryFiles);
            this.filteredFileList.set(entryFiles);
            this.sortBySortPosition();
            this.loading.set(false);
          }),
          untilDestroyed(this),
        )
        .subscribe();
    }
  }

  private sortBySortPosition() {
    this.filteredFileList()?.sort(
      (a: any, b: any) => a.sortPosition - b.sortPosition,
    );
  }
}
